import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Spinner } from "@/components/ui/spinner";
import { useAuthStore } from "@/stores/useAuthStore";
import { isGodRole } from "@/lib/permissions";
import { ROUTES } from "@/lib/routes";

type GodOnlyRouteProps = {
  children: ReactNode;
};

export default function GodOnlyRoute({ children }: GodOnlyRouteProps) {
  const roles = useAuthStore((s) => s.roles);
  const isRolesLoaded = useAuthStore((s) => s.isRolesLoaded);

  if (!isRolesLoaded) {
    return (
      <div className="flex w-full min-h-[40vh] items-center justify-center">
        <Spinner className="size-6" />
      </div>
    );
  }

  if (!isGodRole(roles)) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <>{children}</>;
}
